export enum Tabs {
  All = 'All',
  Proposals = 'Proposals',
  Agreements = 'Agreements',
  Listings = 'Listings',
  Archive = 'Archive',
}

export enum ListingTabs {
  ListingDetails = 'ListingDetails',
  Contracts = 'Contracts',
  Launch = 'Launch',
}
